export default "__VITE_ASSET__qshu747g__"